/* ==========================================================================
   Campaign Flash Sale — countdown
   Drives every [data-flash-sale] banner on the page. Reads the end time from
   data-flash-end (ISO datetime). Hides the banner once the sale has ended.
   ========================================================================== */
(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function setNum(bar, sel, val) {
    var el = bar.querySelector(sel);
    if (el) el.textContent = pad(val);
  }

  function tick() {
    var bars = document.querySelectorAll('[data-flash-sale]');
    if (!bars.length) return;
    var now = new Date().getTime();

    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var end = Date.parse(bar.getAttribute('data-flash-end') || '');
      if (isNaN(end)) { continue; }

      var diff = end - now;
      if (diff <= 0) {
        bar.setAttribute('hidden', '');
        continue;
      }

      var s = Math.floor(diff / 1000);
      setNum(bar, '[data-flash-days]', Math.floor(s / 86400));
      setNum(bar, '[data-flash-hours]', Math.floor((s % 86400) / 3600));
      setNum(bar, '[data-flash-mins]', Math.floor((s % 3600) / 60));
      setNum(bar, '[data-flash-secs]', s % 60);
    }
  }

  function start() {
    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  // bfcache restore — recompute immediately
  window.addEventListener('pageshow', tick);
})();
